module.exports = __webpack_public_path__ + "static/media/Profile.88ee01e9.svg";